import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  tracker,
} from '@unite-us/client-utils';
import { bindActionCreators } from 'redux';
import IndexDetailView from 'src/components/Dashboard/components/IndexDetailView';
import AllCasesIndex from 'src/components/Dashboard/components/Cases/AllCasesIndex';
import { fetchDashboardCases } from 'actions/Case/Contact/Group';
import _ from 'lodash';
import DetailView from 'src/components/Dashboard/components/DetailView';
import CaseDetailsView from 'src/components/Cases/components/Detail/CaseDetailsView';
import fetchProvidersUserCore from 'src/actions/UserProvider/fetchProvidersUser';
import { isCaseManagementProvider } from 'common/utils/User/userGroup';
import { isCoordinationCenter } from 'common/utils/Group';
import { hasFeatureRole } from 'common/utils/Roles/hasFeatureRole';
import {
  careCoordinatorFilterDefault,
  noneAssignedOption,
} from 'src/components/Dashboard/utils/filterDefaults';
import { getDataOfPage, isDataValid, getResponsePageMismatch } from 'src/components/Dashboard/utils/dataHelpers';
import callOrLog from 'src/common/utils/callOrLog';
import {
  getCCUserNetwork,
} from 'src/components/User/utils';
import { searchNetworkGroups } from 'actions/Group/Network';
import { goToCase } from 'src/components/Cases/utils/routing';
import { careCoordinatorsFilter, serviceTypesFilter } from 'src/components/Dashboard/utils/filter';
import { DASHBOARD_VIEWS, DASHBOARD_EVENTS } from 'common/utils/EventTracker/utils/eventConstants';
import { isSuperNetwork } from 'src/components/Network/utils';
import {
  getAuthorizationStatusesOptions,
  getGroupUsersOptions,
  getPrimaryWorkersOptions,
  getStatusesOptions,
} from 'src/components/Groups/Users/utils';
import { useV4toGetOrganizations } from 'src/common/utils/FeatureFlags/flags';
import labelCustomization from 'src/common/utils/Customization/labels';
import defaultLabels from 'src/constants/labels';
import fetchPrograms from 'src/pages/dashboard/cases/utils/fetchPrograms';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { browserHistory } from 'common/utils/browserHistory';

export class CasesAllCases extends PureComponent {
  constructor(props) {
    super(props);
    this.fetch = this.fetch.bind(this);
    this.fetchAllNetworkGroups = this.fetchAllNetworkGroups.bind(this);
    this.onCellClick = this.onCellClick.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.shouldFetch = this.shouldFetch.bind(this);
    this.fetchRequestId = 0;
    this.fetchGroupsUsers = this.fetchGroupsUsers.bind(this);
    this.fetchPrimaryWorkers = this.fetchPrimaryWorkers.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);
    this.state = {
      activePrograms: [],
      activeUsersInGroup: [],
      primaryWorkers: [],
      page: 1,
      sidx: sortObj?.column || 'updated_at',
      sord: sortObj?.sortDirection || 'desc',
      filters: {
        authorization_statuses: _.get(props, 'filters.authorization_status_filter', []),
        service_types: _.get(props, 'filters.service_types', []),
        programs: _.get(props, 'filters.programs_filter', []),
        care_coordinator_users: _.get(
          props,
          'filters.care_coordinator_users',
          careCoordinatorFilterDefault(props.userId, props.isCaseManager && props.isCC),
        ),
        primary_worker_users: _.get(
          props,
          'filters.primary_worker_users',
          [props.currentEmployee.id],
        ),
      },
      open: false,
    };
  }

  componentDidMount() {
    this.fetch();
    this.props.fetchProvidersUserCore({
      providers: this.props.groupId,
    })
      .then((response) => {
        if (response) {
          const { employees: activeUsersInGroup } = response;
          this.setState({ activeUsersInGroup, primaryWorkers: response.employees });
        }
      });

    const { useV4toSearchNetworkGroups } = this.props;
    if (useV4toSearchNetworkGroups && this.props.networkId) {
      this.fetchAllNetworkGroups();
    }

    if (!useV4toSearchNetworkGroups && this.props.networkId && _.isEmpty(this.props.networkGroups)) {
      this.fetchAllNetworkGroups();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.refetch && nextProps.refetch) {
      this.fetch(this.state.page);
    }
  }

  onClose() {
    this.setState({ open: false });
  }

  onToggle() {
    const { open } = this.state;

    this.setState({ open: !open });
  }

  onCellClick(row) {
    const pagedData = getDataOfPage(this.props.allCases, this.state.page);
    const serviceCase = pagedData.data[row];

    callOrLog(() => this.context.eventTracker(DASHBOARD_EVENTS.allCasesRow, {
      view: DASHBOARD_VIEWS.allCases,
    }, { serviceCase }));

    goToCase({ ...serviceCase, pathname: this.props.pathname });
  }

  onFiltersChange(key, activeFilters, callbacks) {
    let newFilters = activeFilters;
    if (_.isEqual(key, 'care_coordinator_users')) {
      newFilters = careCoordinatorsFilter(activeFilters, callbacks);
    }
    this.setState({
      page: 1,
      filters: _.assign({}, this.state.filters, { [key]: newFilters }),
    }, () => {
      callOrLog(() => {
        const filters = tracker.buildDashboardFilterPayload(this.state, this.props);
        this.context.eventTracker(DASHBOARD_EVENTS.allCasesFilter, filters);
      });
      this.fetch();
    });
  }

  onNextClick() {
    const page = this.state.page + 1;
    this.shouldFetch(page);
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.shouldFetch(page);
  }

  onSortChange = createSortChangeHandler(this);

  fetchAllNetworkGroups(page = 1, search = undefined) {
    const { useV4toSearchNetworkGroups } = this.props;
    return this.props.searchNetworkGroups(
      this.props.networkId,
      {},
      { page, search },
      useV4toSearchNetworkGroups,
    ).then((response) => {
      if (useV4toSearchNetworkGroups) {
        const dropdownResponse = response.map((provider) => ({
          label: provider.name,
          value: provider.id,
          initial: false,
        }));
        return dropdownResponse;
      }
      if (!useV4toSearchNetworkGroups) {
        const nextPage = _.get(response, 'data.paging.next_page');
        if (nextPage) {
          this.fetchAllNetworkGroups(nextPage);
        }
      }
      return true;
    });
  }

  shouldFetch(page) {
    if (isDataValid(this.props.allCases, page)) {
      this.setState({ page });
    } else {
      this.fetch(page);
    }
  }

  fetch(page = 1) {
    const requestId = this.fetchRequestId + 1;
    this.fetchRequestId = requestId;
    const formattedFilters = _.reduce(
      this.state.filters,
      (acc, f, key) => {
        if (f === 'all') {
          return acc;
        }
        return _.merge(acc, { [key]: f });
      },
      {},
    );
    formattedFilters.primary_worker_users = _.uniq(
      _.map(formattedFilters.primary_worker_users, (f) => f.split('-primary_worker')[0]),
    );

    this.setState({ page });
    const fetchPromise = Promise.resolve(this.props.fetchDashboardCases(
      this.props.groupId,
      {
        target: 'allCases',
        sidx: this.state.sidx,
        sord: this.state.sord,
        filters: formattedFilters,
        page,
      },
    )).then((response) => {
      if (requestId !== this.fetchRequestId) {
        return response;
      }

      const responsePage = getResponsePageMismatch(response, page);
      if (responsePage !== null) {
        this.setState({ page: responsePage });
      }

      return response;
    });

    this.props.fetchPrograms(this.props.groupId, null, this.state)
      .then((res) => { this.setState({ activePrograms: res }); });

    return fetchPromise;
  }

  fetchGroupsUsers(search = '') {
    const { groupId, isCC } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        text: search,
        licensed: false,
      },
    })
      .then((response) => {
        if (response) {
          const { employees: activeUsersInGroup } = response;
          if (search === '' && isCC) {
            return _.concat(
              [noneAssignedOption(this.state)],
              getGroupUsersOptions(activeUsersInGroup, this.state),
            );
          }

          return getGroupUsersOptions(activeUsersInGroup, this.state);
        }

        return [];
      });
  }

  fetchPrimaryWorkers(search = '') {
    const { groupId, currentEmployee } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        licensed: false,
        text: search,
      },
    })
      .then((response) => {
        if (response) {
          const { employees: primaryWorkers } = response;

          return getPrimaryWorkersOptions(
            primaryWorkers,
            this.state,
            currentEmployee,
          );
        }

        return [];
      });
  }

  render() {
    const {
      allCases,
      currentGroup,
      currentEmployee,
      groupId,
      isCaseManager,
      isCaseMgmtProvider,
      isCC,
      isFetching,
      params,
      serviceTypes,
      labels,
    } = this.props;
    const {
      activePrograms, activeUsersInGroup, primaryWorkers, open,
    } = this.state;

    const hasPaymentsRole = hasFeatureRole({
      employeeRoles: currentEmployee?.roles,
      targetRoleKey: 'payments',
    });

    let filters = [
      serviceTypesFilter(serviceTypes, this.state.filters.service_types),
    ];

    filters = _.concat(filters, [
      {
        key: 'primary_worker_users',
        name: 'Primary Worker',
        pluralName: 'Primary Workers',
        options: getPrimaryWorkersOptions(
          primaryWorkers,
          this.state,
          currentEmployee,
        ),
        asyncSearch: this.fetchPrimaryWorkers,
      },
      {
        key: 'care_coordinator_users',
        name: labels.CareCoordinator,
        pluralName: `${labels.CareCoordinator}s`,
        options: _.concat(
          [noneAssignedOption(this.state.filters.care_coordinator_users)],
          getGroupUsersOptions(activeUsersInGroup, this.state),
        ),
      },
      {
        key: 'programs_filter',
        name: 'Program',
        pluralName: 'Programs',
        options: activePrograms,
        secondary: true,
        asyncSearch: (query) => this.props.fetchPrograms(this.props.groupId, query, this.state),
      },
      {
        key: 'status_filter',
        name: 'Status',
        pluralName: 'Statuses',
        options: getStatusesOptions(this.state),
      },
      hasPaymentsRole &&
        {
          key: 'authorization_status_filter',
          name: 'Authorization Status',
          pluralName: 'Authorization Statuses',
          options: getAuthorizationStatusesOptions(this.state),
        },
    ]);

    filters = _.compact(filters);

    const innerContentView = (
      <CaseDetailsView
        subjectType="case"
        params={params}
        type="allCases"
        showContactColumn
      />
    );

    const allCasesDetailView = (
      <DetailView
        innerContentView={innerContentView}
      />
    );
    const pagedData = getDataOfPage(allCases, this.state.page);

    return (
      <IndexDetailView
        params={this.props.params}
        DetailView={allCasesDetailView}
        IndexView={AllCasesIndex}
        data={pagedData.data}
        paging={pagedData.paging}
        isFetching={isFetching || pagedData.invalidated}
        onNextClick={this.onNextClick}
        onPrevClick={this.onPrevClick}
        onCellClick={this.onCellClick}
        sortConfig={this.onSortChange}
        setSort={{ sidx: this.state.sidx, sord: this.state.sord }}
        isCC={isCC}
        isCaseManager={isCaseManager}
        isSuperNetwork={isSuperNetwork(currentGroup.networks, groupId)}
        onFiltersChange={this.onFiltersChange}
        filters={_.sortBy(filters, 'name')}
        isCaseMgmtProvider={isCaseMgmtProvider}
        fetchGroupsUsers={this.fetchGroupsUsers}
        onClose={this.onClose}
        onToggle={this.onToggle}
        open={open}
      />
    );
  }
}

CasesAllCases.propTypes = {
  allCases: PropTypes.shape({
    data: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  currentGroup: PropTypes.object.isRequired,
  currentEmployee: PropTypes.object.isRequired,
  fetchDashboardCases: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  isCaseManager: PropTypes.bool.isRequired,
  isCaseMgmtProvider: PropTypes.bool,
  isCC: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  networkGroups: PropTypes.object.isRequired,
  networkId: PropTypes.string,
  params: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  refetch: PropTypes.bool.isRequired,
  searchNetworkGroups: PropTypes.func.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  userId: PropTypes.string.isRequired,
  useV4toSearchNetworkGroups: PropTypes.func.isRequired,
  fetchProvidersUserCore: PropTypes.func.isRequired,
  fetchPrograms: PropTypes.func.isRequired,
  labels: PropTypes.object,
};

CasesAllCases.defaultProps = {
  labels: defaultLabels,
};

function mapStateToProps(state, ownProps) {
  const user = _.wget(state, 'user', {});
  const groupId = _.get(state, 'session.groupId');
  const userGroups = _.get(state, 'groups.data', []);
  const network = getCCUserNetwork(user, groupId);
  const { currentEmployee } = state.globalState;
  const currentGroup = _.find(userGroups, { id: groupId }) || {};

  return {
    allCases: _.get(state, 'dashboard.allCases', {}),
    currentGroup,
    currentEmployee,
    filters: _.get(state, 'dashboard.allCases.filters', {}),
    groupId,
    isCaseMgmtProvider: isCaseManagementProvider(state),
    // CORE-WORK - Need to resolve user.groups migration work
    isCC: isCoordinationCenter(_.get(currentGroup, 'networks', []), groupId),
    isFetching: _.get(state, 'dashboard.allCases.isFetching', false),
    networkGroups: _.get(state, 'networks.groups', {}),
    networkId: _.get(network, 'id', null),
    refetch: _.get(state, 'dashboard.refetch'),
    serviceTypes: _.wget(state, 'serviceTypes.allNetworksAndPrograms', []),
    token: _.get(state, 'session.token', ''),
    user,
    userId: _.wget(user, 'id', ''),
    useV4toSearchNetworkGroups: useV4toGetOrganizations(state),
    pathname: _.wget(ownProps, 'location.pathname', ''),
    labels: labelCustomization(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchDashboardCases,
      fetchPrograms,
      searchNetworkGroups,
      fetchProvidersUserCore,
    }, dispatch),
    dispatch,
  };
}

CasesAllCases.contextTypes = {
  eventTracker: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CasesAllCases);
